// Shard 4 — dictionary entries for MissingPersons.jsx, PublicComms.jsx,
// EmergencyResponse.jsx (page-local text not already auto-translated by the
// shared src/components/ui/* components). Duplicate keys with other shards /
// dictionary.js COMPONENT_STRINGS are harmless (last-merged wins).
const shard4 = {
  // ── generic / shared status & label words ─────────────────────
  "All": "सर्व",
  "Active": "सक्रिय",
  "Located": "सापडले",
  "Resolved": "निकाली",
  "Total": "एकूण",
  "Zone": "झोन",
  "zones": "झोन",
  "Category": "प्रकार",
  "Reported": "नोंदवले",
  "Assigned": "नियुक्त",
  "Contact": "संपर्क",
  "Status": "स्थिती",
  "Type": "प्रकार",
  "Time": "वेळ",
  "Reach": "पोहोच",
  "reach": "पोहोच",
  "Language": "भाषा",
  "Channels": "माध्यमे",
  "Highest": "सर्वाधिक",
  "Medium": "मध्यम",
  "Risk": "जोखीम",
  "deployed": "तैनात",
  "Available": "उपलब्ध",
  "Responding": "प्रतिसाद देत आहे",
  "Responded": "प्रतिसाद दिला",
  "Pending": "प्रलंबित",
  "Corrected": "दुरुस्त केले",
  "Flagged": "चिन्हांकित",
  "Ready": "सज्ज",
  "Standby": "सज्ज",
  "Live": "थेट",
  "Operational": "कार्यरत",

  // ── MissingPersons.jsx ──────────────────────────────────────────
  "Active Case Detail — Click to expand": "सक्रिय केस तपशील — विस्तारण्यासाठी क्लिक करा",
  // Split so the case counts can be computed live from missingPersonData.cases
  // instead of being baked into the sentence (was hardcoded 11/6/2/3, drifted
  // from the actual 8-case list).
  "MP COMMAND DESK — 14:33 IST —": "एमपी कमांड डेस्क — 14:33 IST —",
  "CASES ACTIVE": "केसेस सक्रिय",
  "Missing Person & Vulnerable Pilgrim Command — Simhastha 2027": "हरवलेली व्यक्ती व असुरक्षित यात्रेकरू कमांड — सिंहस्थ २०२७",
  "total cases today ·": "एकूण केसेस आज ·",
  "resolved ·": "निकाली ·",
  "located ·": "सापडले ·",
  "active ·": "सक्रिय ·",
  "826 CCTV feeds live · AI face match at 88.4% · Broadcast reached 38.6K pilgrims · 58 volunteer search members deployed":
    "826 सीसीटीव्ही फीड्स सुरू · एआय चेहरा ओळख 88.4% वर · प्रसारण 38.6 हजार यात्रेकरूंपर्यंत पोहोचले · 58 स्वयंसेवक शोध सदस्य तैनात",
  "CCTV Active": "सीसीटीव्ही सक्रिय",
  "Volunteers": "स्वयंसेवक",
  "volunteers": "स्वयंसेवक",
  "Helpline": "मदत क्रमांक",
  "Avg Resolve": "सरासरी निराकरण",
  "Consent-Based Vulnerable Pilgrim Support — DPDP 2023": "संमतीवर आधारित असुरक्षित यात्रेकरू सहाय्य — डीपीडीपी २०२३",
  "All biometric matching and face recognition uses": "सर्व बायोमेट्रिक जुळणी आणि चेहरा ओळख यासाठी वापर केला जातो",
  "explicit consent-based workflows": "स्पष्ट संमतीवर आधारित कार्यप्रणाली",
  "AI face match results are advisory only — human officer must confirm before any action.":
    "एआय चेहरा जुळणीचे निकाल केवळ सल्लारूप आहेत — कोणतीही कारवाई करण्यापूर्वी मानवी अधिकाऱ्याने पुष्टी करणे आवश्यक आहे.",
  "Data used only for reunification and deleted within 72 hours of event close.":
    "डेटा केवळ पुनर्मिलनासाठी वापरला जातो आणि कार्यक्रम संपल्यानंतर ७२ तासांत हटवला जातो.",
  "No punitive action taken from AI facial recognition alone.":
    "केवळ एआय चेहरा ओळखीच्या आधारे कोणतीही दंडात्मक कारवाई केली जात नाही.",
  "Child cases require guardian consent at every step.": "बालकांच्या केसेसमध्ये प्रत्येक टप्प्यावर पालकांची संमती आवश्यक आहे.",
  "Consent Gateway": "संमती प्रवेशद्वार",
  "Human-in-Loop": "मानवी सहभाग",
  "72hr Data Deletion": "७२ तास डेटा हटवणे",
  "No Punitive AI": "दंडात्मक एआय नाही",
  "Guardian Auth for Minors": "अल्पवयीनांसाठी पालक अधिकृतता",
  "Children": "मुले",
  "Elderly": "वृद्ध",
  "Disabled": "दिव्यांग",
  "Med. Risk": "वैद्यकीय धोका",
  "Child": "मूल",
  "Adult": "प्रौढ",
  "Mon": "सोम",
  "Tue": "मंगळ",
  "Wed": "बुध",
  "Thu": "गुरू",
  "Fri": "शुक्र",
  "Sat": "शनि",
  "Case ID": "केस आयडी",
  "Name / Description": "नाव / वर्णन",
  "Situation": "परिस्थिती",
  "Physical Description": "शारीरिक वर्णन",
  "AI Face Match Status": "एआय चेहरा ओळख स्थिती",
  "Human officer confirmation required before any action — DPDP 2023":
    "कोणतीही कारवाई करण्यापूर्वी मानवी अधिकाऱ्याची पुष्टी आवश्यक — डीपीडीपी २०२३",
  "Actions Taken": "केलेल्या कृती",
  "Broadcast Performance": "प्रसारण कामगिरी",
  "Reported:": "नोंदवले:",

  "Unknown Child ~7yrs": "अज्ञात मूल ~7 वर्षे",
  "Elderly Male ~74yrs": "वृद्ध पुरुष ~७४ वर्षे",
  "Disabled Female ~52yrs": "दिव्यांग महिला ~52 वर्षे",
  "Male ~48yrs": "पुरुष ~४८ वर्षे",
  "Child ~5yrs, Girl": "मूल ~५ वर्षे, मुलगी",
  "Elderly Female ~68yrs": "वृद्ध महिला ~६८ वर्षे",
  "Unknown Male ~60yrs": "अज्ञात पुरुष ~६० वर्षे",
  "Child ~8yrs, Boy": "मूल ~८ वर्षे, मुलगा",
  "Elderly Female": "वृद्ध महिला",
  "Unknown Male ~60": "अज्ञात पुरुष ~६०",
  "Elderly Male ~71": "वृद्ध पुरुष ~७१",

  "Panchvati Sector 7": "पंचवटी सेक्टर 7",
  "Ramkund Entry 2": "रामकुंड प्रवेशद्वार 2",
  "Kalaram Gate 3": "काळाराम गेट 3",
  "Trimbakeshwar Zone A": "त्र्यंबकेश्वर झोन अ",
  "Nashik Road Camp": "नाशिक रोड कॅम्प",
  "Panchvati South": "पंचवटी दक्षिण",
  "Gangapur Camp Zone B": "गंगापूर कॅम्प झोन ब",
  "Kalaram Temple Area": "काळाराम मंदिर परिसर",
  "Gangapur Camp": "गंगापूर कॅम्प",
  "Kalaram Temple": "काळाराम मंदिर",
  "Ramkund Gate 3": "रामकुंड गेट ३",
  "Panchvati": "पंचवटी",
  "Ramkund Ghat": "रामकुंड घाट",
  "Trimbakeshwar": "त्र्यंबकेश्वर",
  "Nashik Road Stn": "नाशिक रोड स्थानक",
  "Nashik Road": "नाशिक रोड",

  "PA Announcement": "पीए घोषणा",
  "Volunteer search": "स्वयंसेवक शोध",
  "AI CCTV match": "एआय सीसीटीव्ही जुळणी",
  "Family walk-in": "कुटुंब स्वतः आले",
  "Help Desk": "मदत केंद्र",

  "MP-1185 — Boy 7yr": "एमपी-११८५ — मुलगा ७ वर्षे",
  "MP-1183 — Disabled F": "एमपी-११८३ — दिव्यांग महिला",
  "MP-1185 — PA Zones": "एमपी-११८५ — पीए झोन",
  "MP-1184 — Elderly M": "एमपी-११८४ — वृद्ध पुरुष",
  "WhatsApp+SMS": "व्हॉट्सअॅप+एसएमएस",
  "WhatsApp": "व्हॉट्सअॅप",
  "PA System": "पीए यंत्रणा",
  "SMS": "SMS",
  "seen": "पाहिले",
  "leads": "सुगावे",

  "Searching": "शोध सुरू",
  "Sectors 5–9": "सेक्टर ५–९",
  "Gates 1–6": "गेट १–६",
  "Temple North": "मंदिर उत्तर",
  "All zones": "सर्व झोन",
  "Station area": "स्थानक परिसर",
  "Camp zones": "कॅम्प झोन",
  "open": "खुले",

  "CCTV Cameras": "सीसीटीव्ही कॅमेरे",
  "Face Match AI": "चेहरा जुळणी एआय",
  "WhatsApp Broadcast": "व्हॉट्सअॅप प्रसारण",
  "Radio Mesh Network": "रेडिओ मेश नेटवर्क",
  "16 cameras offline — Ramkund Gate 3 area": "१६ कॅमेरे ऑफलाइन — रामकुंड गेट ३ परिसर",
  "Processing 826 active feeds · 88.4% accuracy": "८२६ सक्रिय फीड्सवर प्रक्रिया सुरू · ८८.४% अचूकता",
  "12 speakers offline — Panchvati West": "१२ स्पीकर्स ऑफलाइन — पंचवटी पश्चिम",
  "Integrated with 22K+ pilgrim numbers": "२२ हजारांहून अधिक यात्रेकरू क्रमांकांशी एकत्रित",
  "All 6 zones covered — TETRA encrypted": "सर्व ६ झोन समाविष्ट — टेट्रा एन्क्रिप्टेड",

  "Face Match CNN": "चेहरा जुळणी सीएनएन",
  "Pending Verify": "पडताळणी प्रलंबित",
  "Low confidence": "कमी विश्वासार्हता",
  "AI Face Match Queue": "एआय चेहरा जुळणी रांग",
  "conf.": "विश्वास.",
  "Assigned:": "नियुक्त:",
  "approval required": "मंजुरी आवश्यक",

  "Children (0–14 yrs)": "मुले (०–१४ वर्षे)",
  "Elderly (60+ yrs)": "वृद्ध (60+ वर्षे)",
  "Disabled Pilgrims": "दिव्यांग यात्रेकरू",
  "Medical Risk (pre-exist.)": "वैद्यकीय धोका (पूर्वस्थिती)",
  "Language Barrier": "भाषा अडथळा",
  "Cognitive / Memory": "संज्ञानात्मक / स्मृती",
  "Dedicated child protection desk · Consent guardian required": "समर्पित बाल संरक्षण कक्ष · पालक संमती आवश्यक",
  "Wheelchair service · medical escort · vernacular support": "व्हीलचेअर सेवा · वैद्यकीय एस्कॉर्ट · स्थानिक भाषा सहाय्य",
  "Mobility aid · Camp Beta accessible zone · buddy system": "गतिशीलता साधन · कॅम्प बीटा सुगम्य झोन · सोबती प्रणाली",
  "Priority triage · ambulance pre-assignment": "प्राधान्य तपासणी · रुग्णवाहिका पूर्व-नियुक्ती",
  "Marathi/Hindi/Gujarati/Tamil volunteer translators": "मराठी/हिंदी/गुजराती/तमिळ स्वयंसेवक भाषांतरकार",
  "Wristband ID system · regular check-in at Zone Help Desks": "रिस्टबँड ओळख प्रणाली · झोन मदत कक्षांवर नियमित तपासणी",

  "Child ~7yrs, Boy, yellow kurta, blue pyjama. Last seen Panchvati Sector 7 near Gate 5 at 14:10. Parents Mr. & Mrs. Shinde at Camp Beta.":
    "मूल ~७ वर्षे, मुलगा, पिवळा कुर्ता, निळा पायजमा. शेवटचे पंचवटी सेक्टर ७, गेट ५ जवळ १४:१० वाजता दिसले. पालक श्री. व सौ. शिंदे कॅम्प बीटा येथे.",
  "Height: ~115cm. Short hair. Yellow kurta. Blue pyjama. Wearing rubber slippers.":
    "उंची: ~११५ सेमी. आखूड केस. पिवळा कुर्ता. निळा पायजमा. रबर स्लिपर घातलेले.",
  "PA announcement activated at all 6 zones at 14:18": "१४:१८ वाजता सर्व ६ झोनमध्ये पीए घोषणा सक्रिय",
  "WhatsApp broadcast sent to 22,000 pilgrims": "२२,००० यात्रेकरूंना व्हॉट्सअॅप प्रसारण पाठवले",
  "CCTV scan in progress — Panchvati Gate 5 area": "सीसीटीव्ही स्कॅन सुरू — पंचवटी गेट ५ परिसर",
  "AI face match running (confidence 61%) — awaiting manual confirm": "एआय चेहरा जुळणी सुरू (विश्वासार्हता ६१%) — मानवी पुष्टीची प्रतीक्षा",
  "Parents contacted — at Camp Beta, Gate 6": "पालकांशी संपर्क साधला — कॅम्प बीटा, गेट ६ येथे",
  "22,000 pilgrims reached via WhatsApp/SMS broadcast": "व्हॉट्सअॅप/एसएमएस प्रसारणाद्वारे २२,००० यात्रेकरूंपर्यंत पोहोच",
  "CCTV Gate 5 — 61% confidence — manual verification pending": "सीसीटीव्ही गेट ५ — ६१% विश्वासार्हता — मानवी पडताळणी प्रलंबित",

  "Elderly Male ~74yrs. Wearing white kurta-pyjama. Last seen Ramkund Entry 2 at 14:02. Memory issues — carries a brown bag.":
    "वृद्ध पुरुष ~७४ वर्षे. पांढरा कुर्ता-पायजमा परिधान केलेला. शेवटचा रामकुंड प्रवेशद्वार २ येथे १४:०२ वाजता दिसला. स्मृती समस्या — तपकिरी बॅग सोबत.",
  "Height: ~165cm. Grey hair. Dhoti kurta white. Brown bag. Walks with slight limp.":
    "उंची: ~१६५ सेमी. पांढरे केस. पांढरा धोतर-कुर्ता. तपकिरी बॅग. किंचित लंगडत चालतो.",
  "Located at Gate 4 medical rest area at 14:18": "१४:१८ वाजता गेट ४ वैद्यकीय विश्रांती क्षेत्रात सापडला",
  "Inspector Shinde escorting to family at Camp Alpha": "इन्स्पेक्टर शिंदे कॅम्प अल्फा येथे कुटुंबाकडे घेऊन जात आहेत",
  "Family notified — eta 10 min for reunification": "कुटुंबाला कळवले — पुनर्मिलनासाठी १० मिनिटे अंदाजित वेळ",
  "8,400 pilgrims reached via SMS": "एसएमएसद्वारे ८,४०० यात्रेकरूंपर्यंत पोहोच",
  "CCTV Gate 4 — 94% confidence — confirmed by officer": "सीसीटीव्ही गेट ४ — ९४% विश्वासार्हता — अधिकाऱ्याने पुष्टी केली",

  "Disabled Female ~52yrs. Wheelchair user. Last seen Kalaram Gate 3. Family member Sunil Lokhande searching.":
    "दिव्यांग महिला ~५२ वर्षे. व्हीलचेअर वापरकर्ता. शेवटची काळाराम गेट ३ येथे दिसली. कुटुंबातील सदस्य सुनील लोखंडे शोध घेत आहेत.",
  "Height: ~155cm. Saree — blue/green. Requires wheelchair. May carry bag with medical equipment.":
    "उंची: ~१५५ सेमी. साडी — निळी/हिरवी. व्हीलचेअरची आवश्यकता. वैद्यकीय साहित्याची बॅग असू शकते.",
  "Wheelchair assistance team dispatched": "व्हीलचेअर सहाय्य पथक रवाना",
  "PA announcement at Kalaram zone": "काळाराम झोनमध्ये पीए घोषणा",
  "4,200 pilgrims reached via WhatsApp": "व्हॉट्सअॅपद्वारे ४,२०० यात्रेकरूंपर्यंत पोहोच",
  "No CCTV match yet — search ongoing": "अद्याप सीसीटीव्ही जुळणी नाही — शोध सुरू",
  "CCTV Kalaram Gate 3 — 42% confidence — below verification threshold, search ongoing":
    "सीसीटीव्ही काळाराम गेट 3 — 42% विश्वासार्हता — पडताळणी मर्यादेखाली, शोध सुरू",

  // ── PublicComms.jsx ─────────────────────────────────────────────
  "Maha Kumbh AI PUBLIC COMMS COMMAND — NODAL OFFICER NASHIK — 14:35 IST — ALL CHANNELS LIVE":
    "महा कुंभ एआय जनसंपर्क कमांड — नोडल अधिकारी नाशिक — १४:३५ आयएसटी — सर्व माध्यमे सुरू",
  "Public Communication & Trust Layer — Simhastha Nashik 2027": "जनसंपर्क व विश्वास स्तर — सिंहस्थ नाशिक २०२७",
  "42 verified advisories · 38.4 lakh reach · 6 languages · 8 broadcast channels · 9 misinfo reports (7 corrected) · Trust score 87.6% · 4-min avg response":
    "४२ सत्यापित सल्ले · ३८.४ लाख पोहोच · ६ भाषा · ८ प्रसारण माध्यमे · ९ चुकीच्या माहितीचे अहवाल (७ दुरुस्त) · विश्वास गुण ८७.६% · सरासरी ४ मिनिट प्रतिसाद",
  "Trust Index": "विश्वास निर्देशांक",
  "Verified Content Accuracy": "सत्यापित मजकूर अचूकता",
  "Official Source Attribution": "अधिकृत स्रोत निर्धारण",
  "Advisory Response Speed": "सल्ला प्रतिसाद गती",
  "Misinformation Correction": "चुकीच्या माहितीची सुधारणा",
  "Multilingual Coverage": "बहुभाषिक व्याप्ती",
  "Pilgrim Satisfaction": "यात्रेकरू समाधान",
  "Total Reach": "एकूण पोहोच",
  "Engaged": "सहभागी",
  "Misinfo Reach": "चुकीच्या माहितीची पोहोच",
  "Positive": "सकारात्मक",
  "Neutral": "तटस्थ",
  "Negative": "नकारात्मक",
  "AI sentiment analysis — subject to human editorial review. DPDP 2023 compliant. No individual profiling.":
    "एआय भावना विश्लेषण — मानवी संपादकीय पुनरावलोकनाच्या अधीन. डीपीडीपी २०२३ अनुरूप. वैयक्तिक प्रोफाइलिंग नाही.",
  "Verified Public Advisories — Active": "सत्यापित सार्वजनिक सल्ले — सक्रिय",
  "Route": "मार्ग",
  "Medical": "वैद्यकीय",
  "Transport": "वाहतूक",
  "Safety": "सुरक्षा",
  "Missing": "हरवलेले",
  "Correction": "सुधारणा",
  "Marathi/Hindi": "मराठी/हिंदी",
  "Marathi": "मराठी",
  "Hindi/Marathi": "हिंदी/मराठी",
  "Verified": "सत्यापित",
  "AI conf:": "एआय विश्वासार्हता:",
  "Full Message": "संपूर्ण संदेश",
  "Authorised By": "अधिकृत करणारे",
  "Translations": "भाषांतरे",
  "Broadcast Channels": "प्रसारण माध्यमे",
  "Target Zones": "लक्ष्य झोन",
  "No corrections needed": "सुधारणा आवश्यक नाही",
  "correction issued": "सुधारणा जारी केली",
  "Marathi · Hindi · English · Gujarati": "मराठी · हिंदी · इंग्रजी · गुजराती",
  "Marathi · Hindi": "मराठी · हिंदी",
  "Hindi · Marathi · Gujarati": "हिंदी · मराठी · गुजराती",
  "Marathi · Hindi · English · Gujarati · Tamil · Telugu": "मराठी · हिंदी · इंग्रजी · गुजराती · तमिळ · तेलुगु",
  "6 Languages": "६ भाषा",
  "Entry Gate 2 Ramkund is at capacity. Use Gate 4 via Godavari Bridge.": "रामकुंड प्रवेशद्वार २ पूर्ण क्षमतेवर आहे. गोदावरी पुलामार्गे गेट ४ वापरा.",
  "Free medical camps at Panchvati, Camp Beta. Water ORS available.": "पंचवटी, कॅम्प बीटा येथे मोफत वैद्यकीय शिबिरे. पाणी व ओआरएस उपलब्ध.",
  "MSRTC shuttle SR-04 delayed. Next bus in 22 min at Bay 7.": "एमएसआरटीसी शटल एसआर-०४ विलंबित. पुढील बस बे ७ वर २२ मिनिटांत.",
  "Carry water. Temperature 38°C. Avoid crowd density areas near Ramkund.": "पाणी सोबत ठेवा. तापमान ३८°से. रामकुंड जवळील गर्दीचे क्षेत्र टाळा.",
  "Missing child (Boy ~7yr, yellow kurta) last seen Panchvati Sector 7.": "हरवलेले मूल (मुलगा ~७ वर्षे, पिवळा कुर्ता) शेवटचे पंचवटी सेक्टर ७ येथे दिसले.",
  "Entry Gate 2 at Ramkund is at capacity (92%). Pilgrims are being diverted to Gate 4 via Godavari Bridge Route. Follow crowd management staff instructions.":
    "रामकुंड प्रवेशद्वार २ पूर्ण क्षमतेवर आहे (९२%). यात्रेकरूंना गोदावरी पूल मार्गे गेट ४ कडे वळवले जात आहे. गर्दी व्यवस्थापन कर्मचाऱ्यांच्या सूचनांचे पालन करा.",
  "Free medical camps are operational at Panchvati (Camp Beta). ORS, drinking water, first-aid and heat treatment available free of cost.":
    "पंचवटी (कॅम्प बीटा) येथे मोफत वैद्यकीय शिबिरे कार्यरत आहेत. ओआरएस, पिण्याचे पाणी, प्रथमोपचार आणि उष्णता उपचार मोफत उपलब्ध.",
  "MSRTC shuttle SR-04 towards Trimbakeshwar is delayed by 22 minutes due to traffic at Godavari Bridge. Next bus expected at Bay 7, 14:45.":
    "त्र्यंबकेश्वरकडे जाणारी एमएसआरटीसी शटल एसआर-०४ गोदावरी पुलावरील वाहतुकीमुळे २२ मिनिटे विलंबित आहे. पुढील बस बे ७ वर १४:४५ वाजता अपेक्षित.",
  "Temperature 38°C with heat index 41°C. All pilgrims are advised to carry water, wear light-coloured clothing, use available shaded corridors and avoid crowds near Ramkund.":
    "तापमान ३८°से, उष्णता निर्देशांक ४१°से. सर्व यात्रेकरूंना पाणी सोबत ठेवण्याचा, फिकट रंगाचे कपडे घालण्याचा, उपलब्ध सावलीच्या मार्गांचा वापर करण्याचा आणि रामकुंडजवळील गर्दी टाळण्याचा सल्ला दिला जातो.",
  "A child (boy, approximately 7 years, yellow kurta) was last seen in Panchvati Sector 7 at 14:12. Parents or anyone with information contact Helpline 14425 or nearest Police Post.":
    "एक मूल (मुलगा, अंदाजे ७ वर्षे, पिवळा कुर्ता) शेवटचे पंचवटी सेक्टर ७ येथे १४:१२ वाजता दिसले. पालक किंवा माहिती असणाऱ्यांनी मदत क्रमांक १४४२५ किंवा जवळच्या पोलीस चौकीशी संपर्क साधावा.",
  "DD Sahyadri": "डीडी सह्याद्री",
  "AIR Nashik": "आकाशवाणी नाशिक",
  "Official WhatsApp": "अधिकृत व्हॉट्सअॅप",
  "Sarkari App": "सरकारी अॅप",
  "SMS Gateway": "एसएमएस गेटवे",
  "Volunteer Network": "स्वयंसेवक नेटवर्क",
  "Lokmat": "लोकमत",
  "Lokmat Nashik": "लोकमत नाशिक",
  "Ramkund": "रामकुंड",
  "Godavari Bridge": "गोदावरी पूल",
  "Camp Alpha": "कॅम्प अल्फा",
  "Camp Beta": "कॅम्प बीटा",
  "Trimbak Road": "त्र्यंबक रोड",
  "Camp Delta": "कॅम्प डेल्टा",
  "All Zones": "सर्व झोन",
  "Sector 7": "सेक्टर ७",
  "Twitter/X": "ट्विटर/एक्स",
  "Facebook": "फेसबुक",
  "SMS chain": "एसएमएस साखळी",
  "Fake alert: Ramkund closed for 3 hours": "खोटा अलर्ट: रामकुंड ३ तास बंद",
  "False rumour: stampede at Panchvati": "खोटी अफवा: पंचवटी येथे चेंगराचेंगरी",
  "Incorrect route advisory spreading": "चुकीचा मार्ग सल्ला पसरत आहे",
  "Wrong medical camp location circulating": "चुकीचे वैद्यकीय शिबिर स्थान प्रसारित",
  "Misinfo reach:": "चुकीच्या माहितीची पोहोच:",
  "Harm:": "हानी:",
  "HIGH": "उच्च",
  "MED": "मध्यम",
  "Misinformation Command Centre": "चुकीच्या माहिती विरोधी कमांड केंद्र",
  "issued today": "आज जारी केलेल्यांपैकी",
  "reports today": "आजच्या तक्रारींपैकी",
  "AI-detected false content · platform monitoring · government correction deployed":
    "एआय-शोधित खोटा मजकूर · माध्यम निरीक्षण · सरकारी सुधारणा तैनात",
  "Live Monitor": "थेट निरीक्षण",
  "AI detect:": "एआय शोध:",
  "False Content": "खोटा मजकूर",
  "Government Fact": "सरकारी सत्य",
  "Reported by:": "नोंदवणारा:",
  "Correction Broadcast": "सुधारणा प्रसारण",
  "Correction Reach": "सुधारणा पोहोच",
  "pilgrims": "यात्रेकरू",
  "Response Time": "प्रतिसाद वेळ",
  "Ramkund is closed for 3 hours due to stampede": "चेंगराचेंगरीमुळे रामकुंड ३ तास बंद आहे",
  "Ramkund is OPEN. Crowd diversion activated at Gate 2 only. Gate 4 operating normally.":
    "रामकुंड सुरू आहे. केवळ गेट २ वर गर्दी वळवणी सक्रिय. गेट ४ सामान्यपणे सुरू आहे.",
  "Official WhatsApp · AIR Nashik · SMS Gateway — 14:14": "अधिकृत व्हॉट्सअॅप · आकाशवाणी नाशिक · एसएमएस गेटवे — १४:१४",
  "WhatsApp monitoring cell": "व्हॉट्सअॅप निरीक्षण कक्ष",
  "4 min": "४ मिनिटे",
  "Stampede at Panchvati — many injured": "पंचवटी येथे चेंगराचेंगरी — अनेक जखमी",
  "No stampede at Panchvati. Crowd density normal. Minor incident at Ramkund handled.":
    "पंचवटी येथे चेंगराचेंगरी झालेली नाही. गर्दीची घनता सामान्य. रामकुंड येथील किरकोळ घटना हाताळली.",
  "Pending — escalated to SM cell": "प्रलंबित — सोशल मीडिया कक्षाकडे पाठवले",
  "Twitter/X trending monitor": "ट्विटर/एक्स ट्रेंडिंग मॉनिटर",
  "Route via Godavari Bridge closed for private vehicles": "गोदावरी पूल मार्ग खासगी वाहनांसाठी बंद",
  "Godavari Bridge is open for authorised pilgrim buses and shuttle only. Verified advisory ADV-114 issued.":
    "गोदावरी पूल केवळ अधिकृत यात्रेकरू बस व शटलसाठी खुला आहे. सत्यापित सल्ला एडीव्ही-११४ जारी.",
  "Official WhatsApp · DD Sahyadri — 13:28": "अधिकृत व्हॉट्सअॅप · डीडी सह्याद्री — १३:२८",
  "Facebook monitoring cell": "फेसबुक निरीक्षण कक्ष",
  "8 min": "८ मिनिटे",
  "Medical camp at Kalaram closed — go to Panchvati": "काळाराम येथील वैद्यकीय शिबिर बंद — पंचवटीला जा",
  "Kalaram medical post is operational 24×7. Panchvati Camp Beta also operational.":
    "काळाराम वैद्यकीय चौकी २४×७ कार्यरत आहे. पंचवटी कॅम्प बीटादेखील कार्यरत आहे.",
  "SMS Gateway · Volunteer Network — 12:52": "एसएमएस गेटवे · स्वयंसेवक नेटवर्क — १२:५२",
  "SMS chain interception": "एसएमएस साखळी अडवली",
  "Broadcast Channel Dashboard": "प्रसारण माध्यम डॅशबोर्ड",
  "8 live channels · delivery rate · reach · next scheduled broadcast": "८ थेट माध्यमे · वितरण दर · पोहोच · पुढील नियोजित प्रसारण",
  "overview": "आढावा",
  "analytics": "विश्लेषण",
  "TV": "टीव्ही",
  "Radio": "रेडिओ",
  "Digital": "डिजिटल",
  "App": "अॅप",
  "PA": "पीए",
  "Print": "प्रिंट",
  "Network": "नेटवर्क",
  "Excellent": "उत्कृष्ट",
  "Good": "चांगले",
  "Next:": "पुढील:",
  "Signal:": "सिग्नल:",
  "open rate": "ओपन दर",
  "delivered": "वितरित",
  "failed": "अयशस्वी",
  "Sent": "पाठवले",
  "Delivered": "वितरित",
  "Failed": "अयशस्वी",
  "Hindi": "हिंदी",
  "English": "इंग्रजी",
  "Gujarati": "गुजराती",
  "Telugu": "तेलुगू",
  "Tamil": "तमिळ",
  "advisories": "सल्ले",
  "AI translation covers 6 languages · Auto-approved for standard advisories · Human review for critical alerts":
    "एआय भाषांतर ६ भाषांना समाविष्ट करते · मानक सल्ल्यांसाठी स्वयंचलित मंजुरी · गंभीर अलर्टसाठी मानवी पुनरावलोकन",
  "Last:": "शेवटचे:",
  "channels": "माध्यमे",
  "languages": "भाषा",
  "Advisory Title": "सल्ला शीर्षक",
  "Gate 2 Diversion — Marathi/Hindi": "गेट २ वळवणी — मराठी/हिंदी",
  "Heat Advisory — All Languages": "उष्णता सल्ला — सर्व भाषा",
  "Missing Child Alert — Panchvati": "हरवलेले मूल अलर्ट — पंचवटी",
  "Medical Camp Open — Camp Beta": "वैद्यकीय शिबिर सुरू — कॅम्प बीटा",
  "Bus SR-04 Delay Update": "बस एसआर-०४ विलंब अद्ययावत",
  "MIS-28 Correction — Ramkund Open": "एमआयएस-२८ सुधारणा — रामकुंड सुरू",
  "Afternoon Crowd Advisory": "दुपारचा गर्दी सल्ला",
  "ORS Distribution — Zone C Added": "ओआरएस वितरण — झोन क जोडले",
  "Ramkund crowd": "रामकुंड गर्दी",
  "Stampede false rumour": "चेंगराचेंगरी खोटी अफवा",
  "NashikKumbh bus info": "नाशिककुंभ बस माहिती",
  "Medical camp locations": "वैद्यकीय शिबिर स्थाने",
  "ORS water distribution": "ओआरएस पाणी वितरण",
  "Route closed false info": "मार्ग बंद खोटी माहिती",
  "Instagram": "इन्स्टाग्राम",
  "Mixed": "संमिश्र",
  "Correcting": "दुरुस्ती सुरू",
  "Boosted": "प्रोत्साहित",
  "Counter": "प्रतिकार",
  "Upcoming": "आगामी",
  "Completed": "पूर्ण",
  "Scheduled": "नियोजित",
  "District Collector Press Conference — Live Situation Update": "जिल्हाधिकारी पत्रकार परिषद — थेट परिस्थिती अद्ययावत",
  "DCP Nashik Media Briefing — Crowd Management Measures": "डीसीपी नाशिक माध्यम माहिती — गर्दी व्यवस्थापन उपाय",
  "CMO Daily Health Bulletin — Camp Status & Heat Advisory": "सीएमओ दैनिक आरोग्य माहितीपत्रक — कॅम्प स्थिती व उष्णता सल्ला",
  "CM Office Media Interaction — Simhastha Preparedness": "मुख्यमंत्री कार्यालय माध्यम संवाद — सिंहस्थ सज्जता",
  "Maha Kumbh AI Evening Situation Report — War Room Broadcast": "महा कुंभ एआय सायंकाळ परिस्थिती अहवाल — वॉर रूम प्रसारण",
  "Nashik Collectorate": "नाशिक जिल्हाधिकारी कार्यालय",
  "Police HQ": "पोलीस मुख्यालय",
  "Civil Hospital": "सिव्हिल हॉस्पिटल",
  "Nashik Circuit House": "नाशिक सर्किट हाऊस",
  "Maha Kumbh AI War Room": "महा कुंभ एआय वॉर रूम",
  "Leader / Contact": "नेता / संपर्क",
  "Area": "क्षेत्र",
  "Role": "भूमिका",
  "Contacted": "संपर्क साधला",
  "Message / Action": "संदेश / कृती",
  "Panchvati Ward": "पंचवटी वॉर्ड",
  "Nashik Road Colony": "नाशिक रोड कॉलनी",
  "Gangapur Area": "गंगापूर परिसर",
  "Trimbakeshwar Village": "त्र्यंबकेश्वर गाव",
  "Nashik City": "नाशिक शहर",
  "Head Pujari": "मुख्य पुजारी",
  "Ward Sarpanch": "वॉर्ड सरपंच",
  "RWA President": "आरडब्ल्यूए अध्यक्ष",
  "Community Leader": "समुदाय नेता",
  "Grampanchayat": "ग्रामपंचायत",
  "Church Leader": "चर्च नेता",
  "Briefed": "माहिती दिली",
  "Crowd advisory shared with temple committee": "मंदिर समितीसोबत गर्दी सल्ला सामायिक केला",
  "Volunteer coordination confirmed for 500 people": "५०० लोकांसाठी स्वयंसेवक समन्वय निश्चित",
  "Water distribution points shared with residents": "रहिवाशांसोबत पाणी वितरण केंद्रे सामायिक केली",
  "Prayer timing coordination to avoid peak crowd": "जास्तीत जास्त गर्दी टाळण्यासाठी प्रार्थना वेळ समन्वय",
  "Alternate route map distributed in village": "गावात पर्यायी मार्ग नकाशा वितरित",
  "Church network spreading safety advisories": "चर्च नेटवर्कद्वारे सुरक्षा सल्ला प्रसारित",
  "Metric": "मापदंड",
  "Nashik 2015": "नाशिक २०१५",
  "Nashik 2019": "नाशिक २०१९",
  "Simhastha 2027": "सिंहस्थ २०२७",
  "Change": "बदल",
  "Advisories Issued": "जारी केलेले सल्ले",
  "Languages": "भाषा",
  "Misinfo Corrected": "दुरुस्त केलेली चुकीची माहिती",
  "Digital Channels": "डिजिटल माध्यमे",
  "Trust Score": "विश्वास गुण",
  "First": "प्रथम",
  "2027 digital expansion (WhatsApp, Sarkari App, SMS Gateway) accounts for 90% of reach increase vs 2019.":
    "२०२७ मधील डिजिटल विस्तार (व्हॉट्सअॅप, सरकारी अॅप, एसएमएस गेटवे) हा २०१९ च्या तुलनेत ९०% पोहोच वाढीचे कारण आहे.",
  "AI social monitoring — no individual user tracking · DPDP 2023 compliant":
    "एआय सोशल मीडिया निरीक्षण — कोणत्याही वैयक्तिक वापरकर्त्याचा मागोवा नाही · डीपीडीपी २०२३ अनुरूप",

  // ── EmergencyResponse.jsx ───────────────────────────────────────
  "EOC ACTIVE — THREAT LEVEL: HIGH — 14:33 IST": "ईओसी सक्रिय — धोका पातळी: उच्च — १४:३३ आयएसटी",
  "Maha Kumbh AI Emergency Operations Centre — Simhastha 2027": "महा कुंभ एआय आपत्कालीन कार्य केंद्र — सिंहस्थ २०२७",
  // Split into fragments so the incident/CRITICAL counts can be computed
  // live from `activeIncidents` instead of baked into the sentence.
  "active incidents": "सक्रिय घटना",
  "EOC manned 24/7 · Collector-level command authority · All agency radios bridged · NDRF on 22-min standby · AI situational awareness active":
    "ईओसी 24/7 कार्यरत · जिल्हाधिकारी स्तरावरील कमांड अधिकार · सर्व एजन्सी रेडिओ जोडलेले · एनडीआरएफ 22 मिनिटांच्या सज्जतेत · एआय परिस्थितीजन्य जागरूकता सक्रिय",
  "INC Active": "घटना सक्रिय",
  "SLA OK": "एसएलए ठीक",
  "AMB Fleet": "रुग्णवाहिका ताफा",
  "NDRF Ready": "एनडीआरएफ सज्ज",
  "Active Incident War Room": "सक्रिय घटना वॉर रूम",
  "CRITICAL": "गंभीर",
  "In Progress": "प्रगतीपथावर",
  "Monitoring": "निरीक्षणाधीन",
  "Escalated": "वाढवलेले",
  "Elapsed:": "निघून गेलेला वेळ:",
  "SLA ETA:": "एसएलए अंदाजित वेळ:",
  "Done": "पूर्ण",
  "Situation Report": "परिस्थिती अहवाल",
  "Assigned Units": "नियुक्त तुकड्या",
  "AI RECOMMENDATION — Confidence:": "एआय शिफारस — विश्वासार्हता:",
  "Human officer approval required before AI recommendation is actioned (DPDP 2023)":
    "एआय शिफारस अंमलात आणण्यापूर्वी मानवी अधिकाऱ्याची मंजुरी आवश्यक (डीपीडीपी २०२३)",
  "SOP Checklist": "एसओपी तपासणी यादी",
  "Util. Rate": "वापर दर",
  "Field Unit Deployment Detail": "क्षेत्रीय पथक तैनाती तपशील",
  "Ambulance Fleet": "रुग्णवाहिका ताफा",
  "Fire Stations": "अग्निशमन केंद्रे",
  "NDRF Platoons": "एनडीआरएफ प्लाटून",
  "ETA:": "अंदाजित वेळ:",
  "ETA": "अंदाजित वेळ",
  "available": "उपलब्ध",
  "on-scene": "घटनास्थळी",
  "en-route": "मार्गावर",
  "blocked": "अडवलेले",
  "Engines": "इंजिन",
  "Pumps": "पंप",
  "Personnel": "कर्मचारी",
  "Strength": "संख्याबळ",
  "Strength:": "संख्याबळ:",
  "Readiness": "सज्जता",
  "Police": "पोलीस",
  "Ambulance": "रुग्णवाहिका",
  "Fire Eng.": "अग्निशमन इंजिन",
  "Health": "आरोग्य",
  "Fire": "अग्निशमन",
  "NDRF": "एनडीआरएफ",
  "Municipal": "महानगरपालिका",
  "Revenue": "महसूल",
  "Target": "उद्दिष्ट",
  "BREACH": "उल्लंघन",
  "Incidents": "घटना",
  "Ambulance (min)": "रुग्णवाहिका (मिनिट)",
  "Police (min)": "पोलीस (मिनिट)",
  "Fire (min)": "अग्निशमन (मिनिट)",
  "Volunteer (min)": "स्वयंसेवक (मिनिट)",
  "Total:": "एकूण:",
  "Resp:": "प्रतिसाद:",
  "Pend:": "प्रलंबित:",
  "Total SOS": "एकूण एसओएस",
  "Backup:": "बॅकअप:",
  "beds": "खाटा",
  "OVER": "जास्त",
  "NEAR": "जवळ",
  "OK": "ठीक",
  "Heatstroke": "उष्माघात",
  "Dehydration": "निर्जलीकरण",
  "Minor Injury": "किरकोळ दुखापत",
  "Serious": "गंभीर",
  "Zone Officer / PSI": "झोन अधिकारी / पीएसआय",
  "Dy. Commissioner / DCP": "उपायुक्त / डीसीपी",
  "District Collector": "जिल्हाधिकारी",
  "Chief Minister EOC": "मुख्यमंत्री ईओसी",
  "Field radio + WhatsApp": "फील्ड रेडिओ + व्हॉट्सअॅप",
  "TETRA + direct call": "टेट्रा + थेट कॉल",
  "EOC hotline": "ईओसी हॉटलाइन",
  "State command": "राज्य कमांड",
  "SLA < 50%": "एसएलए < ५०%",
  "SLA breached": "एसएलए उल्लंघन",
  "CRITICAL unresolved >15 min": "गंभीर १५ मिनिटांहून अधिक काळ निराकरण न झालेले",
  "Mass casualty / NDRF activation": "मोठी जीवितहानी / एनडीआरएफ सक्रियता",
  "Avg Response Time (min)": "सरासरी प्रतिसाद वेळ (मिनिट)",
  "Total Incidents": "एकूण घटना",
  "SLA Compliance (%)": "एसएलए पालन (%)",
  "Kumbh Nashik 2015": "कुंभ नाशिक २०१५",
  "Kumbh Nashik 2019": "कुंभ नाशिक २०१९",
  "Simhastha 2027 Now": "सिंहस्थ २०२७ सद्यस्थिती",
  "AI actions logged for DPDP 2023 audit trail. All AI-triggered field actions require human officer sign-off within 60 seconds.":
    "एआय कृती डीपीडीपी २०२३ ऑडिट ट्रेलसाठी नोंदवल्या जातात. सर्व एआय-चालित क्षेत्रीय कृतींना ६० सेकंदांत मानवी अधिकाऱ्याची सही आवश्यक आहे.",

  "Crowd surge density >9/m²": "गर्दीची घनता वाढ >9/m²",
  "Water tanker not arrived": "पाण्याचा टँकर पोहोचला नाही",
  "Ambulance access blocked": "रुग्णवाहिका मार्ग अडवला",
  "Shelter overload Camp 3": "निवारा अतिभार कॅम्प 3",
  "Missing child — Panchvati Sec7": "बेपत्ता मूल — पंचवटी सेक्टर 7",
  "Heatstroke cluster — Zone D": "उष्माघात समूह — झोन D",
  "Ramkund Ghat, Entry 2": "रामकुंड घाट, प्रवेशद्वार 2",
  "Panchvati Water Point 8": "पंचवटी जलकेंद्र 8",
  "Camp Beta, Trimbak Rd": "कॅम्प बीटा, त्र्यंबक रोड",
  "Nashik Road Camp 3": "नाशिक रोड कॅम्प 3",
  "Panchvati, Sector 7": "पंचवटी, सेक्टर 7",
  "Godavari Zone D": "गोदावरी झोन D",

  "On Scene": "घटनास्थळी",
  "En Route": "मार्गावर",
  "Blocked": "अवरोधित",
  "Camp Beta / Blocked": "कॅम्प बीटा / अडवलेले",

  "Nashik Central FS": "नाशिक सेंट्रल अग्निशमन केंद्र",
  "Trimbakeshwar FS": "त्र्यंबकेश्वर अग्निशमन केंद्र",
  "Gangapur FS": "गंगापूर अग्निशमन केंद्र",
  "1 Deployed": "१ तैनात",
  "Gangapur": "गंगापूर",
  "Nashik Rd": "नाशिक रोड",

  "Platoon 1 — Ramkund QRF": "प्लाटून १ — रामकुंड क्यूआरएफ",
  "Platoon 2 — Camp Shelter": "प्लाटून २ — कॅम्प निवारा",
  "NDRF-HQ Reserve": "एनडीआरएफ मुख्यालय राखीव",
  "Reserve": "राखीव",
  "Flood rescue + stretchers": "पूर बचाव + स्ट्रेचर",
  "Shelter + evacuation kits": "निवारा + स्थलांतर किट",
  "Full disaster response kit": "पूर्ण आपत्ती प्रतिसाद किट",

  "critical": "गंभीर",
  "high": "उच्च",
  "moderate": "मध्यम",
  "normal": "सामान्य",

  "Ambulance Dispatch": "रुग्णवाहिका रवानगी",
  "Police Response": "पोलीस प्रतिसाद",
  "Fire Response": "अग्निशमन प्रतिसाद",
  "Medical Triage": "वैद्यकीय तपासणी",
  "NDRF Deployment": "एनडीआरएफ तैनाती",
  "Volunteer Dispatch": "स्वयंसेवक रवानगी",

  "Crowd/Medical": "गर्दी/वैद्यकीय",
  "Lost Person": "हरवलेली व्यक्ती",
  "Structural": "संरचनात्मक",

  "Pune NDRF Battalion": "पुणे एनडीआरएफ बटालियन",
  "Aurangabad Ambulance Hub": "औरंगाबाद रुग्णवाहिका केंद्र",
  "MH State Disaster Auth.": "महाराष्ट्र राज्य आपत्ती प्राधिकरण",
  "IAF Sarpotdar (Heli)": "भारतीय हवाई दल सरपोतदार (हेली)",
  "Army 1 EME Centre": "सेना १ ईएमई केंद्र",
  "Relief": "मदत",
  "Air Med": "हवाई वैद्यकीय",
  "Military": "लष्करी",
  "On Standby": "सज्ज स्थितीत",
  "Alerted": "सतर्क केले",
  "Contingency": "आकस्मिक सज्जता",

  "TETRA Radio (P25)": "टेट्रा रेडिओ (पी२५)",
  "4G / LTE Network": "४जी / एलटीई नेटवर्क",
  "Satellite Link": "उपग्रह लिंक",
  "PA System — Zones": "पीए यंत्रणा — झोन",
  "Field Walkie-Talkie": "फील्ड वॉकी-टॉकी",
  "Degraded E2": "क्षीण ई२",
  "Satellite": "उपग्रह",
  "TETRA": "टेट्रा",
  "Hand-held": "हातातील उपकरण",

  "Camp Alpha — Ramkund": "कॅम्प अल्फा — रामकुंड",
  "Camp Beta — Panchvati": "कॅम्प बीटा — पंचवटी",
  "Camp Gamma — Trimbak": "कॅम्प गॅमा — त्र्यंबक",
  "Civil Hospital Ref.": "सिव्हिल हॉस्पिटल संदर्भ",

  "Crowd density exceeded 9.2/m² at Ramkund Entry 2. Gates temporarily sealed. Alternate routing via Gate 4 in progress.":
    "रामकुंड प्रवेशद्वार २ येथे गर्दीची घनता ९.२/मी² पेक्षा जास्त झाली. गेट तात्पुरते बंद. गेट ४ मार्गे पर्यायी मार्गीकरण सुरू.",
  "AI recommends hard cap at 150/min — crowd velocity indicates surge risk at 15:10":
    "एआयची शिफारस: प्रति मिनिट १५० ची कठोर मर्यादा — गर्दीचा वेग १५:१० वाजता उसळीचा धोका दर्शवतो",
  "Seal Entry 2 immediately": "प्रवेशद्वार २ त्वरित बंद करा",
  "Redirect crowd to Gate 4 via PA announcement": "पीए घोषणेद्वारे गर्दी गेट ४ कडे वळवा",
  "Deploy stanchion barriers at Bridge Road": "ब्रिज रोडवर स्टँचियन अडथळे तैनात करा",
  "Request CCTV zoom on Gate 2 cluster": "गेट २ समूहावर सीसीटीव्ही झूमची विनंती करा",
  "Reduce entry to 200 pilgrims/min": "प्रवेश दर मिनिट २०० यात्रेकरूंपर्यंत कमी करा",
  "Escalate to DCP if crowd density remains >8 after 15 min": "१५ मिनिटांनंतर गर्दीची घनता >८ राहिल्यास डीसीपीकडे पाठवा",

  "Water tanker WTK-14 failed to arrive at Panchvati Water Point 8. Heat index 41°C. ORS distribution halted.":
    "पाणी टँकर डब्ल्यूटीके-१४ पंचवटी वॉटर पॉइंट ८ येथे पोहोचला नाही. उष्णता निर्देशांक ४१°से. ओआरएस वितरण थांबले.",
  "AI suggests diverting TK-18 from Gangapur Camp (lower risk zone) to Panchvati — saves 11 min":
    "एआयचे सुचवणे: टीके-१८ गंगापूर कॅम्प (कमी धोका झोन) वरून पंचवटीकडे वळवा — ११ मिनिटे वाचतील",
  "Dispatch backup tanker TK-22 immediately": "बॅकअप टँकर टीके-२२ त्वरित रवाना करा",
  "Alert Zone B health team for heatstroke watch": "उष्माघात निरीक्षणासाठी झोन ब आरोग्य पथकाला सतर्क करा",
  "Enable mobile ORS vans in 500m radius": "५०० मीटर परिघात मोबाइल ओआरएस व्हॅन सक्रिय करा",
  "Inform CM control room if unresolved in 20 min": "२० मिनिटांत निराकरण न झाल्यास मुख्यमंत्री नियंत्रण कक्षाला कळवा",

  "Ambulance AMB-07 access blocked at Trimbak Road junction. Patient — heatstroke, serious. Road blocked by unauthorised vehicles.":
    "रुग्णवाहिका एएमबी-०७ चा प्रवेश त्र्यंबक रोड जंक्शनवर अडवला गेला. रुग्ण — उष्माघात, गंभीर. अनधिकृत वाहनांमुळे रस्ता अडवला.",
  "AI predicts 4 more ambulance corridor conflicts in next 2 hrs — recommend dynamic ambulance lane designation":
    "एआयचा अंदाज: पुढील २ तासांत आणखी ४ रुग्णवाहिका मार्ग संघर्ष — गतिशील रुग्णवाहिका मार्गिका नियुक्तीची शिफारस",
  "Request immediate police escort for AMB-07": "एएमबी-०७ साठी त्वरित पोलीस एस्कॉर्टची विनंती करा",
  "Dispatch tow truck TW-02 to clear obstruction": "अडथळा दूर करण्यासाठी टो ट्रक टीडब्ल्यू-०२ रवाना करा",
  "Stabilise patient at Camp Beta until AMB-07 arrives": "एएमबी-०७ पोहोचेपर्यंत रुग्णाला कॅम्प बीटा येथे स्थिर करा",
  "Escalate to DCP if not cleared in 5 min": "5 मिनिटांत निराकरण न झाल्यास DCP कडे वाढवा",
  "Log NCB registration of blocking vehicles": "अडथळा आणणाऱ्या वाहनांची एनसीबी नोंदणी करा",

  "Nashik Road Camp 3 at 138% occupancy. Structural load limit near. Overflow pilgrims sleeping on approach road.":
    "नाशिक रोड कॅम्प ३ १३८% क्षमतेवर. संरचनात्मक भार मर्यादेजवळ. अतिरिक्त यात्रेकरू प्रवेश रस्त्यावर झोपलेले.",
  "AI projects Camp 3 structural stress stabilises if 800 pilgrims moved to Gangapur Camp by 16:00":
    "एआयचा अंदाज: १६:०० पर्यंत ८०० यात्रेकरूंना गंगापूर कॅम्पमध्ये हलवल्यास कॅम्प ३ चा संरचनात्मक ताण स्थिर होईल",
  "Halt new admissions to Camp 3": "कॅम्प ३ मध्ये नवीन प्रवेश थांबवा",
  "Open overflow tent zone OFZ-B (capacity 2,400)": "अतिरिक्त तंबू झोन ओएफझेड-बी उघडा (क्षमता २,४००)",
  "Transport excess occupants via bus BR-09": "बस बीआर-०९ द्वारे अतिरिक्त रहिवाशांची वाहतूक करा",
  "Conduct headcount and register displaced pilgrims": "गणती करा आणि विस्थापित यात्रेकरूंची नोंदणी करा",

  "Missing child ~7yrs, Boy, yellow kurta, last seen Panchvati Sector 7 at 14:10. Parents registered at Camp Beta.":
    "हरवलेले मूल ~७ वर्षे, मुलगा, पिवळा कुर्ता, शेवटचे पंचवटी सेक्टर ७ येथे १४:१० वाजता दिसले. पालक कॅम्प बीटा येथे नोंदणीकृत.",
  "AI CCTV scan matched: child possibly spotted Gate 5 at 14:28 — request manual confirmation":
    "एआय सीसीटीव्ही स्कॅन जुळणी: मूल गेट ५ वर १४:२८ वाजता दिसले असण्याची शक्यता — मानवी पुष्टीची विनंती",
  "Post description at all 6 zone PA systems": "सर्व ६ झोन पीए यंत्रणांवर वर्णन प्रसारित करा",
  "Broadcast on WhatsApp, SMS, IVR": "व्हॉट्सअॅप, एसएमएस, आयव्हीआरवर प्रसारण करा",
  "Deploy constable at Panchvati entry/exit": "पंचवटी प्रवेश/निर्गम येथे कॉन्स्टेबल तैनात करा",
  "Check CCTV at Gate 6 area": "गेट ६ परिसरात सीसीटीव्ही तपासा",
  "Notify Camp Beta parents with updates every 15 min": "दर १५ मिनिटांनी कॅम्प बीटा पालकांना अद्ययावत माहिती द्या",

  "Heatstroke cluster at Godavari Zone D — 14 cases in 45 min window. Medical team dispatched, ORS deployed.":
    "गोदावरी झोन डी येथे उष्माघात समूह — ४५ मिनिटांत १४ प्रकरणे. वैद्यकीय पथक रवाना, ओआरएस तैनात.",
  "AI heat risk model shows Zone D will cool by 16:30 — maintain medical presence until then":
    "एआय उष्णता धोका मॉडेल दर्शवते: झोन डी १६:३० पर्यंत थंड होईल — तोपर्यंत वैद्यकीय उपस्थिती कायम ठेवा",
  "Transport critical cases to Civil Hospital": "गंभीर रुग्णांना सिव्हिल हॉस्पिटलला हलवा",
  "Set up shaded rest zone in Zone D": "झोन डी मध्ये सावलीचे विश्रांती क्षेत्र तयार करा",
  "Increase water distribution in Zone D to 5-min intervals": "झोन डी मध्ये पाणी वितरण ५ मिनिटांच्या अंतराने वाढवा",
  "Surveillance for additional cases": "अतिरिक्त प्रकरणांसाठी देखरेख",

  "Crowd surge alert triggered — Ramkund Entry 2 density 9.2/m²": "गर्दी उसळी अलर्ट सक्रिय — रामकुंड प्रवेशद्वार २ घनता ९.२/मी²",
  "Gate 2 sealed, crowd diverting to Gate 4": "गेट २ बंद, गर्दी गेट ४ कडे वळवली जात आहे",
  "Requested police escort for AMB-07 on Trimbak Road": "त्र्यंबक रोडवर एएमबी-०७ साठी पोलीस एस्कॉर्टची विनंती केली",
  "Patient stabilised at Camp Beta — awaiting ambulance": "रुग्णाला कॅम्प बीटा येथे स्थिर केले — रुग्णवाहिकेची प्रतीक्षा",
  "NDRF Platoon 2 activated for Camp 3 shelter overflow": "कॅम्प ३ निवारा अतिरिक्त भारासाठी एनडीआरएफ प्लाटून २ सक्रिय",
  "Backup tanker TK-22 auto-dispatched to Panchvati Water Point 8": "बॅकअप टँकर टीके-२२ पंचवटी वॉटर पॉइंट ८ कडे स्वयंचलितपणे रवाना",
  "Missing child INC-8817 registered — broadcast activated": "हरवलेले मूल आयएनसी-८८१७ नोंदवले — प्रसारण सक्रिय",
  "Camp 3 occupancy at 138% — escalated to District Collector": "कॅम्प ३ व्याप्ती १३८% — जिल्हाधिकाऱ्यांकडे पाठवले",
  "CCTV match: Missing child possibly sighted at Gate 5": "सीसीटीव्ही जुळणी: हरवलेले मूल गेट ५ वर दिसले असण्याची शक्यता",
  "Heatstroke cluster Zone D — 14 cases — medical team dispatched": "उष्माघात समूह झोन डी — १४ प्रकरणे — वैद्यकीय पथक रवाना",
};

export default shard4;
